<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="card shadow-sm">
          <div class="card-body p-4">
            <h4 class="card-title text-center mb-4 text-primary">Login</h4>
            <form @submit.prevent="handleLogin">
              <div class="mb-3">
                <label for="email" class="form-label text-secondary">Email address</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  v-model="email"
                  required
                  aria-label="Email address"
                />
              </div>
              <div class="mb-3">
                <label for="password" class="form-label text-secondary">Password</label>
                <div class="input-group">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control"
                    id="password"
                    v-model="password"
                    required
                    aria-label="Password"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="togglePassword"
                    aria-label="Toggle password visibility"
                  >
                    <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                  </button>
                </div>
              </div>
              <!-- <div class="d-grid">
                <button type="submit" class="btn btn-primary btn-block">
                  Login
                </button>
              </div> -->

              <div class="d-grid">
  <button type="submit" class="btn btn-primary btn-block" :disabled="loading">
    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span v-else>Login</span>
  </button>
</div>

            </form>

            <!-- Success or Error Message -->
            <div v-if="message" class="mt-3" :class="messageClass">
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      message: '',
      messageClass: '',
      loading: false, // Loading state

    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async handleLogin() {
  this.loading = true; // Start loading spinner
  try {
    const response = await axios.post('/adminlogin', {
      email: this.email,
      password: this.password,
    });

    if (response && response.data) {
      const { token, id, first_name, last_name, email, profile_photo } = response.data;

      // Store all fields in localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('id', id);
      localStorage.setItem('first_name', first_name);
      localStorage.setItem('last_name', last_name);
      localStorage.setItem('email', email);
      localStorage.setItem('password', this.password); // Storing password is not recommended for security reasons
      localStorage.setItem('profile_photo', profile_photo);

      this.message = 'Login successful!';
      this.messageClass = 'text-success';

      // // Navigate to admin home page
      // this.$router.push('/adminHome');
      // Navigate to admin home page with query parameter
      this.$router.push({ path: "/adminHome", query: { currentPage: "home" } });

    } else {
      this.message = 'Unexpected response structure';
      this.messageClass = 'text-danger';
    }
  } catch (error) {
    console.error('Login error:', error);

    if (error.response) {
      this.message = 'Login failed: ' + (error.response.data.message || 'Unknown error');
    } else if (error.request) {
      this.message = 'Login failed: No response from server';
    } else {
      this.message = 'Login failed: ' + error.message;
    }
    this.messageClass = 'text-danger';
  } finally {
    this.loading = false; // Stop loading spinner
  }
},
//     async handleLogin() {
//       this.loading = true; // Start loading spinner
//   try {
//     const response = await axios.post('/adminlogin', {
//       email: this.email,
//       password: this.password,
//     });

//     // Check if response is valid and contains a token
//     if (response && response.data) {
//       // Assuming the response contains a token
//       localStorage.setItem('token', response.data.token); // Store token in localStorage
//       this.message = 'Login successful!';
//       this.messageClass = 'text-success';

//       // Navigate to admin home page
//       this.$router.push('/adminHome');
//     } else {
//       // Handle unexpected response structure
//       this.message = 'Unexpected response structure';
//       this.messageClass = 'text-danger';
//     }
//   } catch (error) {
//     // Log the error for debugging
//     console.error('Login error:', error);

//     // Handle API error gracefully
//     if (error.response) {
//       // Server responded with a status other than 200 range
//       this.message = 'Login failed: ' + (error.response.data.message || 'Unknown error');
//     } else if (error.request) {
//       // Request was made but no response was received
//       this.message = 'Login failed: No response from server';
//     } else {
//       // Something happened in setting up the request
//       this.message = 'Login failed: ' + error.message;
//     }
    
//     this.messageClass = 'text-danger';
//   }
// },

  }
};
</script>

<style scoped>
.container {
  max-width: 400px;
}

.card {
  border: none;
  border-radius: 10px;
}

.card-body {
  background-color: #f8f9fa;
}

.card-title {
  font-weight: bold;
}

.form-label {
  font-weight: 600;
}

.input-group .btn-outline-primary {
  border-radius: 0 5px 5px 0;
  border-width: 1px; /* Ensure the border width is consistent */
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #004085;
}

.btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.text-success {
  color: green;
}

.text-danger {
  color: red;
}
</style>
